import type CalendarItem from 'owa-service/lib/contract/CalendarItem';
import type { FreeBusyStatus, ScheduleItem } from 'owa-graph-schema';

export default function convertCalendarItemToScheduleItem(item: CalendarItem): ScheduleItem {
    return {
        isPrivate: item.Sensitivity === 'Private',
        location: item.Location?.DisplayName,
        status: convertBusyTypeToFreeBusyStatus(item.FreeBusyType ?? 'NoData'),
        subject: item.Subject,
        isException: item.CalendarItemType === 'Exception',
        isReminderSet: item.ReminderIsSet,
        isMeeting: item.IsMeeting,
        isRecurring: item.IsRecurring || item.CalendarItemType === 'Occurrence',
        id: item.ItemId?.Id,
        startTime: {
            dateTime: `${item.Start}${item.StartTimeZoneId ? '' : 'Z'}`,
            timeZone: { name: item.StartTimeZoneId ?? 'UTC' },
        },
        endTime: {
            dateTime: `${item.End}${item.EndTimeZoneId ? '' : 'Z'}`,
            timeZone: { name: item.EndTimeZoneId ?? 'UTC' },
        },
    };
}

// Declared only in this file since the rest of client-web should not be using
// the OWS BusyType definition
function convertBusyTypeToFreeBusyStatus(status: string): FreeBusyStatus {
    switch (status) {
        case 'NoData':
            return 'Unknown';
        case 'Free':
            return 'Free';
        case 'Tentative':
            return 'Tentative';
        case 'Busy':
            return 'Busy';
        case 'OOF':
            return 'Oof';
        case 'WorkingElsewhere':
            return 'WorkingElsewhere';
        default:
            throw new Error('Invalid value for type BusyType');
    }
}
